import { createFileRoute, Outlet } from '@tanstack/react-router';
import { Link } from '#/components/link.tsx';

export const Route = createFileRoute('/admin')({
	ssr: false,
	head: () => ({
		meta: [{ name: 'robots', content: 'noindex, nofollow' }],
	}),
	component: () => (
		<>
			<nav className="container h-navbar flex items-center">
				<Link to="/admin">Admin</Link>
			</nav>
			<div className="children flex min-h-safe-screen flex-col">
				<main
					id="main-content"
					className="flex-1 [view-transition-name:main-content]"
				>
					<Outlet />
				</main>
			</div>
		</>
	),
});
